<div class="p-4 py-8 w-10 mx-auto my-0">
  <div class="flex align-items-start justify-content-between">
    <h3 i18n>Users</h3>
    <button
      pButton
      label="Add User"
      type="button"
      class="p-button-raised p-button-warning"
      icon="pi pi-plus-circle"
      style="margin-bottom: 10px"
      (click)="createClicked()"
    ></button>
  </div>
  <p-table
    #dt
    class="users-table"
    styleClass="p-datatable-sm"
    [value]="filteredUsers"
    [paginator]="true"
    [(rows)]="pageSize"
    [(first)]="first"
    [showCurrentPageReport]="true"
    [currentPageReportTemplate]="translateCurrentPageReportTemplate()"
    [resizableColumns]="true"
    [rowsPerPageOptions]="availablePageSizes"
    [loading]="isLoading"
  >
    <ng-template pTemplate="caption">
      <div class="flex justify-content-end py-3">
        <span class="p-float-label">
          <input
            id="float-input"
            type="text"
            pInputText
            [(ngModel)]="selectedSearchText"
            (ngModelChange)="searchTextChanged()"
          />
          <label for="float-input" i18n>Search by Username</label>
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th class="current" i18n>Username</th>
        <th class="current" i18n>First Name</th>
        <th class="current" i18n>Last Name</th>
        <th class="current" i18n>Roles</th>
        <th class="current" i18n>Countries</th>
        <th class="current text-right pr-7" i18n>Actions</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-user>
      <tr>
        <td>{{ user.username }}</td>
        <td>{{ user.firstName }}</td>
        <td>{{ user.lastName }}</td>
        <td>{{ user.roles.join(', ') }}</td>
        <td>
          <span *ngFor="let country of countries">
            <img
              *ngIf="user.countryIds.includes(country.id)"
              src="{{ country.flagUrl }}"
              style="display: inline-block"
              width="30"
            />
            {{ ' ' }}
          </span>
        </td>
        <td class="actions text-right">
          <button
            pButton
            type="button"
            icon="pi pi-flag"
            class="p-button-outlined p-button-warning"
            (click)="addOrRemoveCountries($event, user)"
            pTooltip="Assign countries to the user"
            tooltipPosition="left"
          ></button>
          <button
            pButton
            type="button"
            icon="pi pi-file-edit"
            class="p-button-outlined p-button-warning"
            (click)="editClicked($event, user)"
          ></button>
          <button
            pButton
            type="button"
            icon="pi pi-trash"
            class="p-button-outlined p-button-warning"
            (click)="confirmDelete($event, user)"
          ></button>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <p-toast></p-toast>
  <p-confirmPopup></p-confirmPopup>
</div>
